import React, { useState, useEffect } from 'react';
import { Row, Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import RadioInput from 'components/RadioInput';
import Input from 'components/Input';
import { IAddress } from 'models/Address';
import { NumberOutput } from 'utils/NumberOnly';
import { CepNumberOutput } from 'utils/Cep';
import Validator from 'components/Validator';
import { EnumToArray } from 'utils/enumArray/enumHelpers';
import { IReturnType } from 'models/Ticket';

interface IDropAddress {
  protocolCategory?: string;
  returnType?: string;
  setReturnType?: any;
  dropAddressSameInvoice?: boolean;
  setDropAddressSameInvoice?: any;
  dropAddress?: IAddress;
  setDropAddress?: any;
}

const DropAddress: React.FC<IDropAddress> = (props) => {
  const {
    protocolCategory = "",
    returnType,
    setReturnType,
    dropAddressSameInvoice,
    setDropAddressSameInvoice,
    dropAddress,
    setDropAddress,
  } = props;

  const [showQuestionDropAddress, setShowQuestionDropAddress] = useState(false);

  function selectReturnType(value: string) {
    if (value === returnType) {
      setReturnType('');
      return;
    }
    setReturnType(value);
  }

  useEffect(() => {
    const nameAndIdCategory = ['1', 'DEVOLUÇÃO'];
    setShowQuestionDropAddress(protocolCategory === '1');

    if (!nameAndIdCategory.includes(protocolCategory)) {
      setDropAddressSameInvoice(true);
      setReturnType('ON_DELIVERY');
    }
  }, [protocolCategory]);

  useEffect(() => {
    if (dropAddressSameInvoice) setDropAddress({});
  }, [dropAddressSameInvoice]);

  return showQuestionDropAddress ? (
    <>
      <Column className="mt-5">
        <Text className="mb-2 color-blue-gray" size={12}>
          Tipo de devolução
        </Text>
        <Validator value={returnType} name="Tipo de devolução" required>
          <Row className="flex-md-column">
            {EnumToArray(IReturnType).map((el, index) => (
              <Row
                key={index}
                className="w-md-100 mt-md-2"
                style={{ width: 200 }}
              >
                <RadioInput
                  id={el.key}
                  onClick={() => selectReturnType(el.key)}
                  checked={
                    returnType !== undefined &&
                    returnType.toUpperCase() === el.key
                  }
                >
                  <Text className="color-blue-gray">{el.value}</Text>
                </RadioInput>
              </Row>
            ))}
          </Row>
        </Validator>
      </Column>
      <Column className="mt-5">
        <Text className="mb-2 color-blue-gray" size={12}>
          Endereço de Coleta
        </Text>
        <Row className="flex-md-column">
          <Row className="w-md-100 mt-md-2" style={{ width: 200 }}>
            <RadioInput
              id="some-as-note"
              stateName="dropAddressSameInvoice"
              onClick={() => setDropAddressSameInvoice(true)}
              checked={dropAddressSameInvoice === true}
            >
              <Text className="color-blue-gray">Mesmo da nota</Text>
            </RadioInput>
          </Row>
          <Row className="w-md-100 mt-md-2" style={{ width: 200 }}>
            <RadioInput
              id="new-address"
              stateName="dropAddressSameInvoice"
              onClick={() => setDropAddressSameInvoice(false)}
              checked={dropAddressSameInvoice === false}
            >
              <Text className="color-blue-gray">Novo endereço</Text>
            </RadioInput>
          </Row>
        </Row>
      </Column>
      {dropAddressSameInvoice === false && (
        <>
          <Text className="mt-5 color-blue-gray" size={12}>
            Por favor informar o endereço para coleta da devolução.
          </Text>
          <Row className="mt-5 flex-md-column">
            <Column className="flex-1">
              <Text className="mb-2 color-blue-gray" size={12}>
                CEP
              </Text>
              <Input
                onChange={(e: any) =>
                  setDropAddress({
                    ...dropAddress,
                    zipCode: CepNumberOutput(e.target.value),
                  })
                }
                className="w-100"
                type="text"
                name="CEP"
                placeholder="CEP"
                value={CepNumberOutput(dropAddress?.zipCode || '')}
                required
              />
            </Column>
            <Column className="flex-2 ml-4 ml-md-0 mt-md-2">
              <Text className="mb-2 color-blue-gray" size={12}>
                Endereço
              </Text>
              <Input
                onChange={(e: any) =>
                  setDropAddress({ ...dropAddress, street: e.target.value })
                }
                className="w-100"
                type="text"
                name="Endereço"
                placeholder="Endereço"
                value={dropAddress?.street || ''}
                required
              />
            </Column>
            <Column className="flex-1 ml-4 ml-md-0 mt-md-2">
              <Text className="mb-2 color-blue-gray" size={12}>
                Número
              </Text>
              <Input
                onChange={(e: any) =>
                  setDropAddress({
                    ...dropAddress,
                    number: NumberOutput(e.target.value),
                  })
                }
                className="w-100"
                type="text"
                name="Número"
                placeholder="Número"
                value={dropAddress?.number?.toString() || ''}
                required
                maxLength={6}
              />
            </Column>
            <Column className="flex-2 ml-4 ml-md-0 mt-md-2" />
          </Row>
          <Row className="mt-5 flex-md-column">
            <Column className="flex-1">
              <Text className="mb-2 color-blue-gray" size={12}>
                Bairro
              </Text>
              <Input
                onChange={(e: any) =>
                  setDropAddress({
                    ...dropAddress,
                    neighborhood: e.target.value,
                  })
                }
                className="w-100"
                type="text"
                name="Bairro"
                placeholder="Bairro"
                value={dropAddress?.neighborhood || ''}
                required
              />
            </Column>
            <Column className="flex-2 ml-4 ml-md-0 mt-md-2">
              <Text className="mb-2 color-blue-gray" size={12}>
                Cidade
              </Text>
              <Input
                onChange={(e: any) =>
                  setDropAddress({
                    ...dropAddress,
                    city: e.target.value,
                  })
                }
                className="w-100"
                type="text"
                name="Cidade"
                placeholder="Cidade"
                value={dropAddress?.city || ''}
                required
              />
            </Column>
            <Column className="flex-1 ml-4 ml-md-0 mt-md-2">
              <Text className="mb-2 color-blue-gray" size={12}>
                Estado
              </Text>
              <Input
                onChange={(e: any) =>
                  setDropAddress({
                    ...dropAddress,
                    state: e.target.value.replace(/[^a-zA-Z]+/g, ''),
                  })
                }
                className="w-100"
                type="text"
                name="Estado"
                placeholder="Estado"
                value={dropAddress?.state || ''}
                required
                maxLength={2}
              />
            </Column>
            <Column className="flex-2 ml-4 ml-md-0 mt-md-2" />
          </Row>
        </>
      )}
    </>
  ) : (
    <></>
  );
};

export default DropAddress;
